<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.36 5.04896V28.951C18.36 29.4861 17.9384 29.92 17.4182 29.92C17.1182 29.9191 16.8213 29.858 16.5453 29.7403C16.2692 29.6225 16.0197 29.4505 15.8114 29.2345L10.9358 24.2168C10.7056 23.9781 10.4297 23.7881 10.1246 23.6581C9.81944 23.528 9.4913 23.4607 9.15964 23.46H8.31644C4.85048 23.46 2.04004 20.5679 2.04004 17C2.04004 13.432 4.85048 10.54 8.31644 10.54H9.15964C9.82604 10.54 10.4646 10.268 10.9351 9.78312L15.8107 4.76472C16.0192 4.54864 16.269 4.37668 16.5453 4.25905C16.8216 4.14142 17.1187 4.08051 17.4189 4.07996C17.9384 4.07996 18.36 4.5138 18.36 5.04896ZM25.564 8.42176C25.436 8.2981 25.3343 8.14997 25.2649 7.98618C25.1954 7.8224 25.1596 7.64631 25.1596 7.4684C25.1596 7.29049 25.1954 7.11439 25.2649 6.95061C25.3343 6.78682 25.436 6.63869 25.564 6.51504C25.8256 6.2617 26.1756 6.12005 26.5398 6.12005C26.904 6.12005 27.2539 6.2617 27.5156 6.51504C33.4418 12.3059 33.4418 21.694 27.5156 27.4849C27.2539 27.7382 26.904 27.8799 26.5398 27.8799C26.1756 27.8799 25.8256 27.7382 25.564 27.4849C25.4362 27.3612 25.3345 27.2131 25.2651 27.0494C25.1957 26.8857 25.1599 26.7097 25.1599 26.5319C25.1599 26.354 25.1957 26.178 25.2651 26.0143C25.3345 25.8506 25.4362 25.7025 25.564 25.5788C26.7144 24.4658 27.6293 23.1327 28.254 21.6589C28.8788 20.1851 29.2008 18.6007 29.2008 17C29.2008 15.3992 28.8788 13.8148 28.254 12.341C27.6293 10.8672 26.7144 9.53412 25.564 8.42108V8.42176ZM22.1313 12.414C21.8935 12.168 21.7605 11.8392 21.7605 11.4971C21.7605 11.1549 21.8935 10.8261 22.1313 10.5801C22.2475 10.4599 22.3866 10.3644 22.5405 10.2992C22.6944 10.2339 22.8598 10.2003 23.0269 10.2003C23.194 10.2003 23.3594 10.2339 23.5133 10.2992C23.6671 10.3644 23.8063 10.4599 23.9224 10.5801C27.3857 14.1256 27.3857 19.8743 23.9224 23.4198C23.8063 23.54 23.6671 23.6355 23.5133 23.7008C23.3594 23.766 23.194 23.7996 23.0269 23.7996C22.8598 23.7996 22.6944 23.766 22.5405 23.7008C22.3866 23.6355 22.2475 23.54 22.1313 23.4198C21.8935 23.1738 21.7605 22.845 21.7605 22.5029C21.7605 22.1607 21.8935 21.8319 22.1313 21.5859C24.6045 19.0529 24.6045 14.947 22.1313 12.414Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 34,
    },
    height: {
      type: Number,
      default: 34,
    },
    fill: {
      type: String,
      default: "#8D5185",
    },
  },
};
</script>

<style lang="scss" scoped></style>
